angular.module('natura').provider("pggDummyProvider", [ function() {
  /**
   * CONFIG
   */
  var config = {
    feature : null,
    valid : null,
    properties : null,
    name : null,
    id : null
  };
  this.$get = [ function() {
    /**
     * GETTERS AND SETTERS
     */
    var _getConfig = function() {
      return config;
    };
    var _getFeature = function(obj) {
      return obj.feature;
    };
    var _setFeature = function(obj, feature) {
      obj.feature = feature;
    };
    var _getValid = function(obj) {
      return obj.valid;
    };
    var _setValid = function(obj, valid) {
      obj.valid = valid;
    };
    var _getProperties = function(obj) {
      return obj.properties;
    };
    var _setProperties = function(obj, properties) {
      obj.properties = properties;
    };
    var _getName = function(obj) {
      return obj.name;
    };
    var _setName = function(obj, name) {
      obj.name = name;
    };
    var _getId = function(obj) {
      return obj.id;
    };
    var _setId = function(obj, id) {
      obj.id = id;
    };
    var _clearAll = function(obj) {
      _setFeature(obj, null);
      _setValid(obj, null);
      _setProperties(obj, null);
      _setName(obj, null);
      _setId(obj, null);
    };

    /**
     * RETURNS
     */
    return {
      getConfig : _getConfig,
      getFeature : _getFeature,
      setFeature : _setFeature,
      getValid : _getValid,
      setValid : _setValid,
      getProperties : _getProperties,
      setProperties : _setProperties,
      getName : _getName,
      setName : _setName,
      getId : _getId,
      setId : _setId,
      clearAll : _clearAll
    };
  } ];

} ]);